export default "__VITE_ASSET__DwuhuP56__"